const CLASS_CVS = "cvs";
const PHONE_DEFAULT = "link link--primary link--accent-underline";
const PHONE_HOVER = "link link--primary link--accent-underline hover";
const TEL = "tel:";
const FIFTY_FIFTY_UP = ".cmp-container-50-50__half.cmp-container-50-50__up";
const STRONG = "strong";
const BOLD = "bold"
const FONT_WEIGHT = "font-weight";
const ANCHOR = "a";


const initCvSolutions = () => {
    if (!document.body.classList.contains(CLASS_CVS)) return;
    transformFiftyFiftyElements();
}

const transformFiftyFiftyElements = () => {
    const fiftyFiftyElements = document.querySelectorAll(FIFTY_FIFTY_UP);
    if (fiftyFiftyElements && fiftyFiftyElements.length > 0) {
        for (const fiftyFiftyElement of fiftyFiftyElements) {
            changePhoneStyle(fiftyFiftyElement);
            changeTitleStyleToBold(fiftyFiftyElement);
        }
    }
}

const changePhoneStyle = (fiftyFiftyElement) => {
    const aElements = fiftyFiftyElement.getElementsByTagName(ANCHOR);
    for (const aElement of aElements) {
        if (aElement.href && aElement.href.startsWith(TEL)) {
            aElement.className = PHONE_DEFAULT;
            aElement.onmouseover = function () {
                aElement.className = PHONE_HOVER;
            }
            aElement.onmouseout = function () {
                aElement.className = PHONE_DEFAULT;
            }
        }
    }
}

const changeTitleStyleToBold = (fiftyFiftyElement) => {
    const strongElements = fiftyFiftyElement.getElementsByTagName(STRONG);
    for (const strongElement of strongElements) {
        strongElement.style[FONT_WEIGHT] = BOLD;
    }
}

export { initCvSolutions };